import { Component, OnChanges, AfterViewInit, Input, Renderer2, ElementRef, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { encapsulation } from '../../encapsulation';
import { UBXField } from '../../../models';

@Component({
    selector: 'ubx-field-block',
    templateUrl: './field-block.component.html',
    host: { class: 'ubx-field-block flx f-fd:c p:rl' },
    encapsulation
})
export class UBXFieldBlockComponent implements OnChanges, AfterViewInit {
    @Input() field: UBXField;
    @Input() accent = 'prm';

    @Input() required = false;
    @Input() disabled = false;
    @Input() valid = true;

    hover: boolean;
    focus: boolean;
    value: boolean;

    showPrefix = true;
    showSuffix = true;

    @ViewChild('prefix') prefix: any;
    @ViewChild('suffix') suffix: any;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private cdRef: ChangeDetectorRef,
    ) { }

    ngOnChanges() {
        // this.appendClass(this.accent);
        this.setStates();
    }

    ngAfterViewInit() {
        this.checkFixes();
    }

    private checkFixes() {
        this.showPrefix = this.prefix.nativeElement.children.length > 0;
        this.showSuffix = this.suffix.nativeElement.children.length > 0;
        this.cdRef.detectChanges();
    }

    private setStates() {
        // this.disabled ? this.appendClass('disabled') : this.removeClass('disabled');
        // this.valid ? this.removeClass('invalid') : this.appendClass('invalid');
    }

    private appendClass(names: string) {
        this.renderer.addClass(this.el.nativeElement, names);
    }
    private removeClass(names: string) {
        this.renderer.removeClass(this.el.nativeElement, names);
    }

    @HostListener('mouseover') mouseOver() {
        this.hover = true;
    }
    @HostListener('mouseout') mouseOut() {
        this.hover = false;
    }
}
